// Shape of the `benefits_eligibility_result` workflow value. Under OLIO-2301 the
// BenefitsEligibility action is integration-completed with a rich object (not the old
// scalar `active`/`inactive`), which olio-api serializes to camelCase. The Workflow value
// type stays `string | null` (a documented simplification — tests already cast object
// values with `as any`), so we narrow from `unknown` at the render boundary with the guard
// below. See `BenefitsEligibilityResult.tsx` for rendering.

export interface SnfBucket {
  status?: string;
  coinsurancePercent?: number | null;
  copay?: number | null;
  deductible?: number | null;
  outOfPocket?: number | null;
  per?: string | null;
  dayLimit?: {
    value: number | null;
    unit: string | null;
    period: string | null;
    source: string;
  };
  priorAuth?: { required: string; source: string };
  notes?: string[];
}

export interface SkilledNursingSummary {
  skilledNursingReported?: boolean;
  reason?: string;
  inNetwork?: SnfBucket;
  outNetwork?: SnfBucket;
  serviceTypeCodesSeen?: string[];
}

export interface BenefitsEligibilitySummary {
  activeCoverage?: string;
  coverageDates?: { start: string | null; end: string | null } | null;
  skilledNursing?: SkilledNursingSummary;
}

export interface BenefitsEligibilityResultValue {
  summary?: BenefitsEligibilitySummary;
  classification?: string;
  checks?: unknown[];
}

// Runtime guard: is this workflow value the eligibility result object (vs a scalar the
// human-completed kinds write)? Keeps an object from ever reaching JSX as a raw child.
export function isBenefitsEligibilityResult(value: unknown): value is BenefitsEligibilityResultValue {
  return (
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    ('summary' in value || 'checks' in value || 'classification' in value)
  );
}
